
import { reactive, ref, getCurrentInstance } from 'vue'
import type { ElTree } from 'element-plus'
import type Node from 'element-plus/es/components/tree/src/model/node'
import _edit  from '@/assets/js/edit'

interface Tree {
	id: number
	label: string
	children?: Tree[]
}

export default {
	props: [],
	emits: [ 'onClose' ],
	setup(props, context) {
		const treeRef = ref<InstanceType<typeof ElTree>>()
		
		const getCheckedKeys = () => {
			return treeRef.value!.getCheckedKeys(false)
		}
		const getCheckedNodes = () => {
			return treeRef.value!.getCheckedNodes(false, false)
		}
		const instance = getCurrentInstance()
		
		return {
			treeRef,
			getCheckedNodes,
			getCheckedKeys,
			instance,
			context,
			closeDrawer: ()=>{context.emit('onClose', 'add')},
			view: reactive({}),
			form: reactive({}),
			options: reactive({}),
			setting: reactive({
				moduleApi: '/System/Role/',
				moduleName: '角色',
			}),
			rules: {
				name: [
					{ required: true, message: '请输入角色名称', trigger: 'blur' },
				],
				permissionId: [
					{ required: true, message: '请选择权限', trigger: 'blur' },
				],
			},
		}
	},
	
	mounted: function(){
		this._load(this, _edit)
		this.getTree()
	},
	methods: {
		//获取Tree
		getTree: function(){
			this._post('/System/Permission/tree', {}, (res)=>{
				this.treeData = res.data
				this.$forceUpdate()
			})
		},
		
		//表单提交
		_formSubmit: function(){
			let permissionId = this.getCheckedKeys()
			if(!permissionId || (permissionId.length==0)) return this._msg('请选择权限项目')
			this.form.permissionId = permissionId
			
			this.$refs[this.setting.formName].validate((valid) => {
				if (valid) {
					this._post(this.setting.moduleApi + 'add', this.form, (res)=>{
						this._msg('添加成功')
						this.closeDrawer()
					})
				} else return false
			})
			return false
		}
	}
}
